import { css } from "@emotion/react";
import { mq } from "styles";

const VerifyEmailRequiredCss = {
  pageLayout: css({
    backgroundColor: "#040922",
    backgroundImage:
      "radial-gradient(ellipse at 20% 10%, rgba(56,189,248,0.07) 0%, transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(32,194,241,0.06) 0%, transparent 60%)",
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: "40px 16px",
  }),
  confirmWindow: css({
    background: "#0b1120",
    border: "1px solid rgba(56,189,248,0.12)",
    borderRadius: "20px",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 8px 48px rgba(0, 0, 0, 0.5)",
    padding: "40px 32px",
    [mq.phoneOnly]: {
      width: "100%",
      maxWidth: "340px",
      padding: "32px 24px",
    },
    [mq.tabletUp]: {
      width: "460px",
      maxWidth: "460px",
      padding: "48px 48px",
    },
    [mq.desktopUp]: {
      width: "520px",
      maxWidth: "520px",
    },
  }),
  verifyBody: css({
    backgroundColor: "transparent",
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  }),
};

export default VerifyEmailRequiredCss;
